// Sends profile events to GCF (Cloud Function) for permanent user interest scoring.
// GA4 logging is handled separately by the passive collector via AnalyticsService.

const GCF_ENDPOINT = 'https://process-traveler-event-613221148836.europe-west1.run.app';

function getCredentials(): { userId: string; tourId: string } {
  try {
    const { uID, tID } = JSON.parse(localStorage.getItem('credential_items') || '{}');
    return { userId: uID || '', tourId: tID || '' };
  } catch {
    return { userId: '', tourId: '' };
  }
}

export function dispatchProfileEvent(name: string, data: Record<string, any> = {}) {
  const { userId, tourId } = getCredentials();
  if (!userId) return; // No user, skip

  const payload = {
    userId,
    tourId,
    eventType: name,
    timestamp: Date.now(),
    was_in_radius: data.was_in_radius ?? false,
    ...data,
  };

  try {
    fetch(GCF_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (e) {
    console.error('[dispatchProfileEvent] GCF call failed:', e);
  }
}
